exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".share-button{position:relative;display:inline-block}.share-section{position:absolute;bottom:30px;left:0;background:#fff;border:1px solid #ccc;padding:10px;display:flex;flex-direction:column;gap:10px;width:400px}.custom-file .custom-file-label{text-align:left!important}", ""]);

// exports
